/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */
import Vue from 'vue';

import { resolveRelations } from '@/store/helpers';

const state = {
    byId: {},
    allIds: [],
};

const getters = {
    // Return a single article with the given id.
    find: (state, _, __, rootGetters) => id =>
        // Swap ID referenes with the resolved author objects.
        resolveRelations(state.byId[id], [], rootGetters),
    // Return a list of monitors in the order of `allIds`.
    list: (state, getters) => state.allIds.map(id => getters.find(id)),
};

const actions = {
    // there is no request to load the locations
    // it is only done via GET /teams/{ID}
};

const mutations = {
    add: (state, item) => {
        Vue.set(state.byId, item.id, item);
        if (state.allIds.includes(item.id)) return;
        state.allIds.push(item.id);
    },
};

export default {
    actions,
    getters,
    mutations,
    namespaced: true,
    state,
};
